export const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
export const lerp = (a, b, t) => a + (b - a) * t;

// Runtime-configurable DPR cap
let MAX_DPR_CAP = 1.5;
export function setMaxDprCap(v) { const nv = Number(v); if (Number.isFinite(nv) && nv >= 1) MAX_DPR_CAP = nv; }
export function getMaxDprCap() { return MAX_DPR_CAP; }

// Canvas size locking (prevent resize during gameplay)
let canvasSizeLocked = false;
export function lockCanvasSize() { canvasSizeLocked = true; }
export function unlockCanvasSize() { canvasSizeLocked = false; }

export function fitCanvasToDisplaySize(canvas) {
  // Prevent resizing during gameplay to avoid world coordinate issues
  if (canvasSizeLocked) return false;
  // Prefer the visual viewport to avoid iOS URL-bar resize issues.
  const vw = Math.floor((window.visualViewport?.width || window.innerWidth));
  const vh = Math.floor((window.visualViewport?.height || window.innerHeight));

  // Keep CSS size in sync with the live viewport
  const styleChanged = (
    canvas.style.width !== `${vw}px` || canvas.style.height !== `${vh}px`
  );
  if (styleChanged) {
    canvas.style.width = `${vw}px`;
    canvas.style.height = `${vh}px`;
  }

  // Clamp DPR to protect fill-rate on mobile devices
  const dpr = Math.min(Math.max(1, window.devicePixelRatio || 1), MAX_DPR_CAP);

  const w = Math.round(vw * dpr);
  const h = Math.round(vh * dpr);
  if (canvas.width !== w || canvas.height !== h || styleChanged) {
    canvas.width = w; canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    // Expose the effective DPR so world sizing uses the same scale
    canvas.__dpr = dpr;
    return true;
  }
  return false;
}
